'use strict';
import $ from 'jquery';
import { breakpoint } from '../utils';

export default class M122 {
    static init() {
        $('.module-m122').each((index, el) => {
            new M122($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.windowWidth = $(window).width();
        this.start();
        $(window).on('resize', this.onResize.bind(this));
    }

    onResize(e) {
        if ((this.windowWidth < 568 && $(window).width() > 567) || (this.windowWidth > 567 && $(window).width() < 568)) this.start();
        this.windowWidth = $(window).width();
    }

    start() {
        if (this.el.find('.module-m122-quotes').hasClass('slick-initialized')) this.el.find('.module-m122-quotes').slick('unslick');
        const args = {
            rows: 1,
            arrows: true,
            appendArrows: this.el.find('.module-m122-arrows > div'),
            mobileFirst: true,
            dots: false,
            arrows: true,
            slidesToShow: 1,
            cssEase: 'linear',
            useTransform: true,
            infinite: true,
            prevArrow: '<button type="button" class="slick-prev slick-arrow-' + this.el.data('theme') + '">Previous</button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow-' + this.el.data('theme') + '">Next</button>',
        };
        if ($(window).width() > 567) {
            args.centerMode = true;
            args.centerPadding = '20%';
        }

        this.el.find('.module-m122-quotes').slick(args);
    }
}
